export const SEARCH_APP_REQUEST = 'SEARCH_APP_REQUEST';
export const SEARCH_APP_SUCCESS = 'SEARCH_APP_SUCCESS';
export const SEARCH_APP_FAILURE = 'SEARCH_APP_FAILURE';

export const SEARCH_WALLPAPER_REQUEST = 'SEARCH_WALLPAPER_REQUEST';
export const SEARCH_WALLPAPER_SUCCESS = 'SEARCH_WALLPAPER_SUCCESS';
export const SEARCH_WALLPAPER_FAILURE = 'SEARCH_WALLPAPER_FAILURE';

export const SEARCH_POST_REQUEST = 'SEARCH_POST_REQUEST';
export const SEARCH_POST_SUCCESS = 'SEARCH_POST_SUCCESS';
export const SEARCH_POST_FAILURE = 'SEARCH_POST_FAILURE';

export const SEARCH_COURSE_REQUEST = 'SEARCH_COURSE_REQUEST';
export const SEARCH_COURSE_SUCCESS = 'SEARCH_COURSE_SUCCESS';
export const SEARCH_COURSE_FAILURE = 'SEARCH_COURSE_FAILURE';

export const UPDATE_SEARCH_PARAM = 'UPDATE_SEARCH_PARAM';
export const UPDATE_SEARCH_COUNT = 'UPDATE_SEARCH_COUNT';

export const SEARCH_WALLPAPER_HOT_REQUEST = 'SEARCH_WALLPAPER_HOT_REQUEST';
export const SEARCH_WALLPAPER_HOT_SUCCESS = 'SEARCH_WALLPAPER_HOT_SUCCESS';
export const SEARCH_WALLPAPER_HOT_FAILURE = 'SEARCH_WALLPAPER_HOT_FAILURE';

export const SEARCH_POST_HOT_REQUEST = 'SEARCH_POST_HOT_REQUEST';
export const SEARCH_POST_HOT_SUCCESS = 'SEARCH_POST_HOT_SUCCESS';
export const SEARCH_POST_HOT_FAILURE = 'SEARCH_POST_HOT_FAILURE';

export const SEARCH_COURSE_HOT_REQUEST = 'SEARCH_COURSE_HOT_REQUEST';
export const SEARCH_COURSE_HOT_SUCCESS = 'SEARCH_COURSE_HOT_SUCCESS';
export const SEARCH_COURSE_HOT_FAILURE = 'SEARCH_COURSE_HOT_FAILURE';
